import React from 'react'
import { useNls } from '../../../nls/nlsProvider'
import { formatMoney } from '../../../utils/formatMoney'
import type { OpsCashCountValue, OpsTemplateFieldCashCountField } from '../../../types/ops'

export interface CashCountFieldValueProps {
  field?: OpsTemplateFieldCashCountField
  value: unknown
  currency?: string | null
}

export const CashCountFieldValue: React.FC<CashCountFieldValueProps> = ({
  field,
  value,
  currency,
}) => {
  const { t } = useNls()

  if (!value || typeof value !== 'object') {
    return <span className="opsRegistersKVVal opsRegistersFigures">{t('NLSOpsValueEmpty')}</span>
  }

  const v = value as OpsCashCountValue
  const counted = typeof v.countedMinor === 'number' ? v.countedMinor : 0
  const expected = typeof v.expectedMinor === 'number' ? v.expectedMinor : 0
  const difference = typeof v.differenceMinor === 'number' ? v.differenceMinor : 0
  const tolerance = field?.toleranceMinor ?? 0
  const hasMismatch = Math.abs(difference) > tolerance

  return (
    <div className="opsRegistersCashDisplay">
      <div className="opsRegistersCashDisplaySummary">
        <span className="opsRegistersKVVal opsRegistersFigures">
          {formatMoney(counted, currency)}
        </span>
        {expected > 0 && (
          <span className="opsRegistersFieldHint">
            ({t('NLSOpsRegisterCashCountExpectedLabel')}: {formatMoney(expected, currency)})
          </span>
        )}
      </div>
      {difference !== 0 && (
        <div className={`opsRegistersFigures ${hasMismatch ? 'opsRegistersCashDiffBad' : ''}`}>
          {t('NLSOpsRegisterCashCountDifferenceTotal')}: {difference < 0 ? `−${formatMoney(Math.abs(difference), currency)}` : formatMoney(difference, currency)}
        </div>
      )}
      {v.mismatchReason ? (
        <div className="opsRegistersFieldHint">
          {t('NLSOpsRegisterCashCountMismatchReasonLabel')}: {v.mismatchReason}
        </div>
      ) : null}
    </div>
  )
}
